import { useParams } from 'react-router-dom';
import { useAppSelector } from '@store';
import {
  ButtonPseudo,
  ChangeLogs,
  IconCopy,
  PermissionDenied,
  PermissionEnum,
  Popup,
  SidePanel,
  SidePanelType,
  Textarea,
} from '@ui/src';
import TopUpPanel from '../../../common/top-up-panel';
import { OverviewTopUpPanelsTypes } from '../types';

import commonStyles from '../../../common/common.module.css';
import cn from '../styles.module.css';

const OverviewPanels = ({
  topUpPanelIsOpen,
  setTopUpPanelIsOpen,
  selectedTopUpId,
  setSelectedTopUpId,
  setConvertPopuVisible,
  convertIsLoading,
  convertPopupVisible,
  convertToIndividaul,
  reopenPopupState,
  setReopenPopupVisible,
  setReopenPopupState,
  setReopenError,
  reopenInProgress,
  reopenPopupVisible,
  reopenReason,
  onReopenOrganization,
  reopenError,
  setReopenReason,
  setResetPasswordPopupVisible,
  resetPasswordPopupVisible,
  link,
  token,
  copyIsSuccess,
  onCopy,
  changeLogsPanelIsOpen,
  setChangeLogPanelIsOpen,
  changeLogsIsLoading,
  changeLogsIsFetching,
  getChangeLogsAction,
}: OverviewTopUpPanelsTypes) => {
  const { customerId } = useParams();

  const { activePermissions } = useAppSelector((state) => state.root);
  const { baseInformation, changeLogs, changeLogsPagination } = useAppSelector(
    (state) => state.individualCustomers.info.general,
  );

  const { users } = useAppSelector((state) => state.administrationDictionaries);

  return (
    <>
      <TopUpPanel
        topUpPanelIsOpen={topUpPanelIsOpen}
        setTopUpPanelIsOpen={setTopUpPanelIsOpen}
        selectedTopUpId={selectedTopUpId}
        setSelectedTopUpId={setSelectedTopUpId}
        userAccounts={baseInformation?.accounts?.map((item) => ({
          accountId: item.id,
          account: { fullNumber: item.fullNumber },
          description: item.description,
        }))}
      />
      <Popup
        title="Are you sure you want to convert cof to an individual customer?"
        onCancelClick={() => setConvertPopuVisible(false)}
        okButtonText={convertIsLoading ? 'Loading...' : 'Yes'}
        cancelButtonText="No"
        isVisible={convertPopupVisible}
        isLoading={convertIsLoading}
        onOkClick={() => convertToIndividaul(customerId)}
      />
      <Popup
        title={
          reopenPopupState === 'warning'
            ? 'Reopen organization'
            : 'State the reason for reopening'
        }
        description={
          reopenPopupState === 'warning'
            ? 'The organization will become available again'
            : ''
        }
        onCancelClick={() => {
          setReopenPopupVisible(false);
          setReopenPopupState('warning');
          setReopenError('');
        }}
        okButtonText={reopenInProgress ? 'Loading...' : 'Reopen organization'}
        cancelButtonText="Cancel"
        isVisible={reopenPopupVisible}
        isLoading={reopenInProgress}
        okButtonDisabled={
          Boolean(reopenPopupState === 'comment' && !reopenReason) ||
          reopenInProgress
        }
        onOkClick={() => {
          if (reopenPopupState === 'warning') {
            setReopenPopupState('comment');
          } else if (reopenPopupState === 'comment') {
            onReopenOrganization();
          }
        }}
      >
        <div>
          {reopenPopupState === 'comment' && (
            <>
              {reopenError && (
                <div className={commonStyles.reopenError}>{reopenError}</div>
              )}
              <Textarea
                name="reopenReason"
                value={reopenReason}
                onChange={(e) => setReopenReason(e.target.value)}
                placeholder="Reason"
                labelClassName={commonStyles.reopenReason}
              />
            </>
          )}
        </div>
      </Popup>
      <Popup
        title="Reset customer password"
        description="Send this link to the user for password recovery"
        onCancelClick={() => setResetPasswordPopupVisible(false)}
        isVisible={resetPasswordPopupVisible}
      >
        <div className={cn.resetPasswordLink}>
          <div
            className={`${cn.copySuccess} ${copyIsSuccess ? cn.visible : ''}`}
          >
            Copied!
          </div>
          <span>{`${link}/auth/reset-password?token=${token}`}</span>
          <button
            type="button"
            className={cn.copyButton}
            onClick={onCopy}
            aria-label="Copy link button"
          >
            <IconCopy />
          </button>
        </div>
      </Popup>
      <SidePanel
        isOpen={changeLogsPanelIsOpen}
        onClose={() => {
          setChangeLogPanelIsOpen(false);
        }}
        title="Customer change logs"
        sidepanelExpandedKey="customers-change-logs"
        type={SidePanelType.Accounts}
        footer={
          <div>
            <ButtonPseudo
              text="Close"
              onClick={() => setChangeLogPanelIsOpen(false)}
              bold
            />
          </div>
        }
        closeOnClickOutside
      >
        <>
          {activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST) && (
            <ChangeLogs
              entityType="ORGANIZATION"
              entityId={customerId as string}
              changeLogsIsLoading={changeLogsIsLoading}
              changeLogs={changeLogs}
              activePermission={activePermissions}
              users={users}
              pagination={changeLogsPagination}
              changeLogsIsFetching={changeLogsIsFetching}
              getChangeLogs={getChangeLogsAction}
            />
          )}
          {!activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST) && (
            <PermissionDenied />
          )}
        </>
      </SidePanel>
    </>
  );
};

export default OverviewPanels;
